module.exports = __webpack_public_path__ + "static/img/alibaba.991b4d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/article/alibaba.png
// module id = czm+
// module chunks = 0